export default __webpack_public_path__ + "static/media/fireFN1.e8c77096.svg";